import { captureException, Severity } from '@sentry/node';

export const defaultErrorHandler = (error: unknown) => {
    captureException(error, {
        level: Severity.Warning,
        tags: {
            place: 'failed to post api-campaign events',
            isSsr: false,
        },
    });
};
